import React from 'react'
import IDBanner from './IDBanner'
import IDContent from './IDContent'
import IntegrationPartner from '../IntegrationListing/IntegrationPartner'
import IDVideo from './IDVideo'
import { BaseUrl } from '../../../helper/BaseUrl'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchJson } from '../../../helper/fetchJson'

export default function IntegrationDetails({ initialData }) {
   const { slug } = useParams();
    const [Data, setData] = React.useState(initialData || {});
    const navigate = useNavigate();
    React.useEffect(() => {
      let active = true;

      if (initialData?.slug === slug) {
        setData(initialData);
      } else {
        fetchJson(`${BaseUrl}/api/tms-integration/view/${slug}`)
          .then((result) => {
            if (!active) return;
            if (!result?.integration) {
              navigate("/404");
              return;
            }
            setData(result.integration);
          })
          .catch((error) => console.error('Fetch error:', error.message));
      }

      return () => {
        active = false;
      };
    }, [slug, initialData, navigate])
  
  
  const partner = {
    subTitle: "Find The Right Plan",
    heading: "for Your Business",
    description: "Explore flexible pricing plans designed to fit your logistics needs & support scalable, efficient business growth.",
    buttonText: "see plans & pricing",
    buttonLink: "/pricing",
    bgImage: "/assets/images/integration-detail-pricing.webp",
  }


  return (
    <>
      <IDBanner data={Data}/>
      <IDContent data={Data} />
      <IntegrationPartner data={partner} />
      <IDVideo data={Data}/>
    </>
  )
}
